import {
  CHECKOUT_OUT_PRODUCT_PRICE_TYPE,
  PMS_PRODUCT_STOCK_STATUS,
} from 'commons/options';
import { ProductTaxRegime } from 'constants/france-tax';

export type ProductCategory = {
  id: number;
  name: string;
  nameJa: string;
  nameZh: string;
  nameTw: string;
  value: string;
  children?: ProductCategory[];
  size: string;
  sizeJa: string;
  sizeZh: string;
  sizeTw: string;
};

export type ProductAttributeCode = {
  id: number;
  labelCn: string;
  labelEn: string;
  labelJa: string;
  value: string;
  enabled: boolean;
  categoryId: number;
  parentId: number;
  treeIds?: string;
  sort: number;
};

export enum ProductAttributeCodeNames {
  COLOR = 'color',
  MATERIAL = 'material',
  STAMP = 'stamp',
  RANK = 'rank',
  TYPE = 'type',
  HUE = 'colors',
  HARDWARE = 'hardware',
  ACCESSORIES = 'accessories',
  COLLECTIONS = 'collection',
}

export type PmsProduct = {
  id: number;
  mainCategoryId: number;
  productCategoryId: number;
  name: string;
  pic: string;
  pic2: number;
  productSn: string;
  deleteStatus: number;
  publishStatus: number;
  price: number;
  rank: string;
  rankDescription: string;
  collections: string;
  color: string;
  subTitle: string;
  originalPrice: number;
  stock: number;
  stockStatus?: PMS_PRODUCT_STOCK_STATUS;
  albumPics: string;
  promotionType: number;
  brandName: string;
  createdFrom: number;
  createdBy: string;
  stockPlace: string;
  currency: string;
  createdTime?: string;
  sourceType: number;
  description?: string;
  costPrice?: number;
  careCost?: number | null;
  recycleOrderId?: string;
  recycleOrderCode?: string;
  soldTime?: string;
  orderId?: number;
  entryTime?: string;
  note?: string;
  referencePrice?: number;
  skuType: number;
};

export type PmsProductWithPriceType = PmsProduct & {
  priceType: CHECKOUT_OUT_PRODUCT_PRICE_TYPE;
  quantity: number;
};

export type ProductUpdateInfo = {
  id: number;
  language: string;
  owner?: string;
  productSn: string;
  pic?: string;
  albumPics: string;
  currency: string;
  stockPlace: string;
  originalPrice: number;
  promotionType: number;
  rank: string;
  detailTitle: string;
  attrAccessory: string;
  attrColor?: string;
  attrColorRemark: string;
  attrColors: string;
  attrHardware?: string;
  attrHardwareRemark: string;
  attrMaterial: string;
  attrMaterialRemark: string;
  attrModel: string;
  attrModelFilter: string;
  attrRankDesc: string;
  attrSize: string;
  attrStamp: string;
  attrStampRemark: string;
  attrType: string;
  productCategoryId: number;
  i18nCn: any;
  i18nJa: any;
  i18nTw: any;
  sourceType: number;
  deleteStatus: number;
  publishStatus: number;
  name: string;
  subTitle: string;
  note: string;
  detailDesc: string;
  facebookEnabled?: number;
  referencePrice?: number;
  pmsProductActivityList: {
    id: number;
    createAt: string;
    userName: string;
    detail?: string;
  }[];
  //ToDo 后续不需要
  keywords?: string;
  remark?: string;
  fullStamp?: string;
};

export type ProductCreateInfo = Omit<ProductUpdateInfo, 'id'>;

interface currentcyType {
  [key: string | number]: CURRENCY_ENUM;
}

export enum CURRENCY_ENUM {
  JPY = 'JPY',
  HKD = 'HKD',
  SGD = 'SGD',
  AED = 'AED',
}

export const currencyMap: currentcyType = {
  '1': CURRENCY_ENUM['JPY'],
  '2': CURRENCY_ENUM['HKD'],
  '3': CURRENCY_ENUM['SGD'],
};

export const currencyItems = Object.values(currencyMap).map((d: string) => ({
  label: d,
}));

/** 价签列表 - 添加/编辑价签 */
export interface PriceTagInfo {
  color?: string; //扩展-商品颜色color
  createTime?: string; // 创建时间
  entryTime?: string; // 入库时间
  hardware?: string; //  扩展-商品金属件
  id: number; // 商品ID
  material?: string; // 扩展-商品材质
  name: string; // 商品名称
  price: number; // 价格
  costPrice: number; // 售价价格
  currency: string; // 币种
  productSn: string; // 货号
  rank?: string; // 扩展-状态，等级/成色，用于二手商品
  sourceType?: number; // 商品来源类型， 0 自有， 1 寄卖
  stamp?: string; // 扩展-商品刻印/标记
  brandName: string;
  referencePrice?: number;
  fullStamp?: string;
}

export type ProductPassportUrlItem = {
  productId: number;
  passportUrl: string | null;
};

export type ProductCateType = {
  id: number;
  keywords: string;
  name: string;
  nameJa: string;
  nameZh: string;
  labelCn: string;
  labelEn: string;
  labelJa: string;
  parentId: number;
  navStatus: number;
  showStatus: number;
  treeId: string;
  value: string;
  enabled: boolean;
  categoryId: number;
  treeIds?: string;
  sort: number;
  level: number;
  icon?: string;
  size: string;
  sizeCn: string;
  sizeJa: string;
  sizeTw: string;
  extConfig: string;
  description: string;
};

export type ProductCateListPayload = {
  id?: number;
  prevId?: number;
  pageNum?: number;
  pageSize?: number;
};

export type ProductCateUpdateNavStatusPayload = Pick<
  ProductCateType,
  'navStatus'
> & { ids: string };

export type ProductCateUpdateShowStatusPayload = Pick<
  ProductCateType,
  'showStatus'
> & { ids: string };

export type ProductUpdateInfoNewType = {
  id: number;
  productSn: string;
  albumPics: string;
  name: string;
  publishStatus: number;
  stock: number;
  collections?: string;
  subTitle: string;
  rankDescription: string;
  note: string;
  detailDesc: string;
  detailTitle: string;
  stamp?: string;
  size: string;
  owner?: string;
  accessory: string;
  facebookEnabled: number;
  promotionType: number;
  originalPrice?: number;
  extendType: string;
  productCategoryId: number;
  boxId?: number | null;
  material: string;
  color?: string;
  hardware: string;
  hardwareRemark?: string;
  colorRemark?: string;
  materialRemark?: string;
  stampRemark?: string;
  rank?: string;
  colors?: string;
  stockStatus?: string;
  orderId?: number;
  soldTime?: string;
  brandName?: string;
  price: number;
  costPrice: number;
  careCost?: number | null;
  currency: string;
  referencePrice?: number;
  skuType: number;
  sourceType: number;
  description?: string;
  stockPlace: string;
  pmsProductActivityList?: {
    actId: string;
    actUsername: string;
    actProductId: number;
    actProductSn: string;
    actCreateAt: string;
    actAction: string;
    actDetail: string;
  }[];
  i18nList?: {
    id: string;
    lang: string;
    productId: number;
    name?: string;
    subTitle?: string;
    note?: string;
    detailTitle?: string;
    attrRankDesc?: string;
    attrSize?: string;
    detailDesc?: string;
  }[];
  remark?: string;
  recycleOrder?: {
    memberId: number;
    email: string;
    code: string;
    submissionId?: number;
    id: string;
  };
  fullStamp?: string;
  pic500w: string | null;
  priceHkd: number | null;
  /** 商品税制：STANDARD_TVA | MARGIN（法国） */
  taxRegime?: ProductTaxRegime | null;
  internalImages: string[] | null;
  entryTime?: string;
  sourceProductId?: number;
};
